document.addEventListener("DOMContentLoaded", function () {
  let grid_view = document.getElementById("mobile-grid-view");
  let list_view = document.getElementById("mobile-list-view");

  let filters_count_html = document.getElementById("active-filters-count");
  let filters_count = document.querySelectorAll(
    '[data-armada-selector="active-filters__remove-filter"]'
  );
  let collection_handle = window.shopData.collectionHandle;
  let custom_sort_by = document.getElementById("sort-by");
  let custom_checkbox = document.querySelectorAll(
    '[data-armada-selector="custom_filter_checkbox"]'
  );
  let custom_checkbox_label = document.querySelectorAll(
    '[data-armada-selector="custom_filter_checkbox-label"]'
  );

  let filtersAccordion = document.getElementsByClassName("filters-accordion");
  let sortby_option = document.getElementById("sort-by-option");
  let grid_products = document.getElementsByClassName("grid-product-card");
  let promo_cards = document.getElementsByClassName("new-promo-card-container");

  let productsArray = Array.from(grid_products);
  let promoCardsArray = Array.from(promo_cards);
  let filtersAccordionArray = Array.from(filtersAccordion);

  let mainCollectionContainer = document.getElementById(
    "custom-collection-layout"
  );
  let mainCollectionFilterSidebar = document.getElementById(
    "custom-main-collection-left"
  );
  const mobileLayout = window.matchMedia("(max-width: 768px)");

  const setGridLayoutView = (productsArray, promoCardsArray) => {
    grid_view.querySelectorAll("rect").forEach((rect) => {
      rect.setAttribute("fill", "#294c2b");
    });
    list_view.querySelectorAll("rect").forEach((rect) => {
      rect.setAttribute("fill", "#b4b4b4");
    });
    localStorage.setItem("layout", "grid");

    productsArray.forEach((card) => {
      card.style.width = "47%";
      card.style.flexBasis = "calc(94% / 2)";
      card.classList.add("grid-look");
    });

    promoCardsArray.forEach((card) => {
      card.style.width = "47%";
      card.style.flexBasis = "calc(94% / 2)";
    });
  };

  const setListLayoutView = (productsArray, promoCardsArray) => {
    list_view.querySelectorAll("rect").forEach((rect) => {
      rect.setAttribute("fill", "#294c2b");
    });
    grid_view.querySelectorAll("rect").forEach((rect) => {
      rect.setAttribute("fill", "#b4b4b4");
    });

    productsArray.forEach((card) => {
      card.style.width = "100%";
      card.style.flexBasis = "100%";
      card.classList.remove("grid-look");
    });
    promoCardsArray.forEach((card) => {
      card.style.width = "100%";
      card.style.flexBasis = "100%";
    });
  };

  if (mobileLayout.matches) {
    if (localStorage.getItem("layout") == "grid") {
      setGridLayoutView(productsArray, promoCardsArray);
    } else {
      setListLayoutView(productsArray, promoCardsArray);
    }
  }

  function addClearFiltersOption() {
    if (
      document.querySelectorAll(
        '[data-armada-selector="active-filters__remove-filter"]'
      ).length > 0
    ) {
      let clearFilters = document.createElement("u");
      clearFilters.setAttribute("id", "clear-filters");
      clearFilters.innerHTML = "Clear Filters";

      filters_count_html.appendChild(clearFilters);

      clearFilters.addEventListener("click", () => {
        fetchData(collection_handle, () =>
          removeFilterCheckboxes(custom_checkbox, null, true)
        );
      });
    }
  }

  filters_count_html.innerHTML = "(" + filters_count.length + "): ";

  // Get the container element
  const filtersContainer = document.querySelector(".new-active-filters");

  // Get all filter elements
  const filters = filtersContainer.querySelectorAll(
    ".new-active-filters__remove-filter"
  );

  function scrollToGridTop() {
    mainCollectionContainer.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  grid_view.addEventListener("click", () => {
    grid_products = document.getElementsByClassName("grid-product-card");
    promo_cards = document.getElementsByClassName("new-promo-card-container");
    productsArray = Array.from(grid_products);
    promoCardsArray = Array.from(promo_cards);

    setGridLayoutView(productsArray, promoCardsArray);
    localStorage.setItem("layout", "grid");
  });
  list_view.addEventListener("click", () => {
    grid_products = document.getElementsByClassName("grid-product-card");
    promo_cards = document.getElementsByClassName("new-promo-card-container");
    productsArray = Array.from(grid_products);
    promoCardsArray = Array.from(promo_cards);

    setListLayoutView(productsArray, promoCardsArray);
    localStorage.setItem("layout", "list");
  });

  const removeFilterCheckboxes = (array, item, allFilters) => {
    if (allFilters) {
      array.forEach((checkbox) => {
        if (checkbox.checked) checkbox.checked = !checkbox.checked;
      });
    } else {
      array.forEach((checkbox) => {
        if (checkbox.value == item) {
          checkbox.checked = !checkbox.checked;
        }
      });
    }
  };

  function fetchData(url, triggerFun) {
    custom_loader.classList.remove("hidden");

    fetch(url)
      .then((response) => response.text())
      .then((data) => {
        let collection_grid_div = document.createElement("div");
        let active_filter_div = document.createElement("div");
        let filters_div = document.createElement("div");

        collection_grid_div.innerHTML = data;
        active_filter_div.innerHTML = data;
        filters_div.innerHTML = data;

        let collection_grid_dom = collection_grid_div.querySelector(
          '[data-armada-selector="collection-grid-main"]'
        ).innerHTML;
        let active_filter_html_dom = collection_grid_div.querySelector(
          '[data-armada-selector="active-filters"]'
        ).innerHTML;

        document.querySelector(
          '[data-armada-selector="collection-grid-main"]'
        ).innerHTML = collection_grid_dom;
        document.querySelector(
          '[data-armada-selector="active-filters"]'
        ).innerHTML = active_filter_html_dom;

        if (mobileLayout.matches) {
          grid_products = document.getElementsByClassName("grid-product-card");
          promo_cards = document.getElementsByClassName(
            "new-promo-card-container"
          );
          productsArray = Array.from(grid_products);
          promoCardsArray = Array.from(promo_cards);

          if (localStorage.getItem("layout") == "list") {
            setListLayoutView(productsArray, promoCardsArray);
          } else {
            setGridLayoutView(productsArray, promoCardsArray);
          }
        }

        custom_loader = document.querySelector("#custom_loader");
        custom_loader.classList.add("hidden");

        if (typeof triggerFun === "function") {
          setTimeout(() => {
            triggerFun(); // Ensure DOM changes are complete before scrolling
          }, 0);
        }

        // update url without refreshing the page
        history.replaceState(null, null, url);

        filters_count_html.innerHTML =
          "(" +
          document.querySelectorAll(
            '[data-armada-selector="active-filters__remove-filter"]'
          ).length +
          "): ";

        addClearFiltersOption();
        scrollToGridTop();
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {});
  }
  let details = [...document.querySelectorAll("details.filter-group")];

  // reproduce the bug: filter then remove filter from actives, then add it again
  document.addEventListener("click", (e) => {
    if (
      e.target.matches('[data-armada-selector="active-filters__remove-filter"]')
    ) {
      let remove_item_url = e.target.getAttribute("data-url");
      let remove_item_value = e.target.getAttribute("data-value");

      fetchData(
        remove_item_url,
        removeFilterCheckboxes(custom_checkbox, remove_item_value)
      );
    }
  });

  function encodeUriWithPlus(uri) {
    return encodeURIComponent(uri).replace(/%20/g, "+");
  }

  custom_checkbox_label.forEach((label) => {
    label.addEventListener("click", (e) => {
      custom_checkbox.forEach((checkbox) => {
        if (checkbox.id == label.getAttribute("for")) {
          checkbox.checked = !checkbox.checked;
        }
      });
    });
  });

  custom_checkbox.forEach((checkbox) =>
    checkbox.addEventListener("change", (e) => {
      let current_url = window.location.href;
      e.target.checked = e.target.value;
      let key = e.target.name;
      let val = e.target.value;
      let uri;

      if (current_url.includes("?filter")) {
        uri = current_url + "&" + key + "=" + encodeUriWithPlus(val);
      } else {
        if (current_url.includes("?"))
          uri = current_url + key + "=" + encodeUriWithPlus(val);
        else uri = current_url + "?" + key + "=" + encodeUriWithPlus(val);
      }

      // to clear filter with their symbol when checkbox is double clicked
      if (current_url.includes("&" + key + "=" + encodeUriWithPlus(val))) {
        uri = current_url.replace("&" + key + "=" + encodeUriWithPlus(val), "");
      } else if (
        current_url.includes(key + "=" + encodeUriWithPlus(val) + "&")
      ) {
        uri = current_url.replace(key + "=" + encodeUriWithPlus(val) + "&", "");
      } else if (current_url.includes(key + "=" + encodeUriWithPlus(val))) {
        uri = current_url.replace(key + "=" + encodeUriWithPlus(val), "");
      }

      let fetch_url;

      if (current_url.includes("?sort") || current_url.includes("&sort")) {
        const querySortString = window.location.search;
        const urlParams = new URLSearchParams(querySortString);
        const sort_by_value = urlParams.get("sort_by");
        // fetch_url = '/collections/{{ collection.handle }}?' + queryString + "&sort_by="+sort_by_value
        temp_uri = uri.replace("sort_by=" + sort_by_value, "");
        uri = temp_uri + "&sort_by=" + sort_by_value;
        uri = uri.replace("&&", "&");
      } else {
        // fetch_url = '/collections/{{ collection.handle }}?' + queryString
      }

      fetchData(uri);
    })
  );

  // Sort by functionality START
  custom_sort_by.addEventListener("change", (e) => {
    let url;
    let current_url = window.location.href;

    custom_loader = document.querySelector("#custom_loader");
    custom_loader.classList.remove("hidden");
    if (current_url.includes("filter")) {
      if (current_url.includes("sort_by")) {
        // If there's an old sortby value

        let searchParams = new URLSearchParams(window.location.search);
        searchParams.get("sort_by");
        searchParams.delete("sort_by");
        if (e.target.value != "best-selling")
          searchParams.append("sort_by", e.target.value);

        let updatedSearchString = searchParams.toString();
        url = window.location.pathname + "?" + updatedSearchString;
      } else {
        // If there's no old sortby value
        if (e.target.value == "best-selling") url = current_url;
        else url = current_url + "&sort_by=" + e.target.value;
      }
    } else {
      if (e.target.value == "best-selling")
        url = "/collections/" + collection_handle;
      else
        url =
          "/collections/" + collection_handle + "?sort_by=" + e.target.value;
    }

    fetch(url)
      .then((res) => res.text())
      .then((data) => {
        custom_loader.classList.add("hidden");
        let sortData_container = document.createElement("div");
        sortData_container.innerHTML = data;
        let sortData_html = sortData_container.querySelector(
          '[data-armada-selector="collection-grid-main"]'
        ).innerHTML;
        let collection_grid = document.querySelector(
          '[data-armada-selector="collection-grid-main"]'
        );
        collection_grid.innerHTML = sortData_html;
        history.replaceState(null, null, url);
      });
  });

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  document.addEventListener("scroll", () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let viewportHeight = window.innerHeight;

    // Determine the new top position based on scroll direction
    if (mainCollectionFilterSidebar.offsetHeight > viewportHeight) {
      let currentTop = parseFloat(
        getComputedStyle(mainCollectionFilterSidebar).top
      );
      let maxTop = viewportHeight - mainCollectionFilterSidebar.offsetHeight;

      // When scrolling down
      if (scrollTop > lastScrollTop) {
        mainCollectionFilterSidebar.style.top =
          Math.max(maxTop, currentTop - (scrollTop - lastScrollTop)) + "px";
      }
      // When scrolling up
      else {
        mainCollectionFilterSidebar.style.top =
          Math.min(60, currentTop + (lastScrollTop - scrollTop)) + "px";
      }
    } else {
      mainCollectionFilterSidebar.style.top = "60px";
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For mobile or negative scrolling
  });

  // mobile drawer for filter
  let open_mobile_filter_drawer = document.querySelector(
    '[data-armada-selector="filter-by-mobile-btn"]'
  );
  let close_mobile_filter_drawer = document.querySelector(
    '[data-action="close-mobile-filter-drawer"]'
  );
  let mobile_filter_drawer = document.querySelector(
    '[data-armada-selector="filter-mobile-drawer-selector"]'
  );
  let overlay = document.getElementById("PageOverlay");

  let closeMobileFilter = (e) => {
    e.preventDefault();
    overlay.style.zIndex = 99;
    overlay.style.visibility = "hidden";
    mobile_filter_drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "auto";
  };
  let openMobileFilter = () => {
    overlay.style.zIndex = 150;
    overlay.style.visibility = "visible";
    mobile_filter_drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  };

  open_mobile_filter_drawer.addEventListener("click", openMobileFilter);
  close_mobile_filter_drawer.addEventListener("click", (e) =>
    closeMobileFilter(e)
  );
  overlay.addEventListener("click", (e) => closeMobileFilter(e));
});
